import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';
import GhaPickupStatus from '../../../models/GhaPickupStatus';

import { PO_AWB_SCHEMA } from '../../../utils/pickupOrder';

import SecurityChecks from './SecurityChecks';


interface SecurityChecksContainerProps {
  poAwb: GhaPickupStatusAwb;
  flight?: string;
  doNumber: string;
  code: string;
  number: string;
  awbVer: number;
  statusTransportation: boolean;
  statusShipper: boolean;
  setContainerState: (poAwb: GhaPickupStatusAwb, statusTransportation: boolean, statusShipper: boolean) => void;
  receiveError: Function;
  checkElement: (check: boolean) =>  JSX.Element;
  onlyRead?: boolean;
  deliveredDate: string;
};

interface SecurityChecksContainerState {
  poAwb: GhaPickupStatusAwb;
  flight?: string;
  iac: boolean;
  ds: boolean;
  comat: boolean;
  iacNumber: string;
  dsNumber: string;
  ccsfNumber: string;
  exception: string;
  statusTransportation: boolean;
  statusShipper: boolean;
  securityNote: string;
  itsOkay: boolean;
  ccsfType: 'CCSP' | 'CCSF' | 'N/A';
};

class SecurityChecksContainer extends Component<SecurityChecksContainerProps, SecurityChecksContainerState> {

  state = {
    poAwb: PO_AWB_SCHEMA,
    flight: '',
    iac: false,
    ds: false,
    comat: false,
    iacNumber: '',
    dsNumber: '',
    ccsfNumber: '',
    exception: '',
    statusTransportation: false,
    statusShipper: false,
    securityNote: '',
    itsOkay: false,
    ccsfType: 'N/A' as 'CCSP' | 'CCSF' | 'N/A',
  };

  componentDidUpdate(prevProps: SecurityChecksContainerProps){
    if (prevProps !== this.props) {
      this.load();
    }
  };

  load = (): void => {

    const iac: boolean = this.props.poAwb.transportation_profile === 'iac'? true: false;
    const ds: boolean = this.props.poAwb.transportation_profile === 'ds'? true: false;
    const comat: boolean = this.props.poAwb.transportation_profile === 'comat'? true: false;
    const itsOkay: boolean = this.props.poAwb.its === 'iac_its' ? this.props.poAwb.iacOkay : this.props.poAwb.ccsfOkay;
    const iacNumber: string = iac ? this.props.poAwb.transportation_number : ''
    const dsNumber: string = ds? this.props.poAwb.transportation_number: '';
    const securityNote: string = this.props.poAwb.security_notes ?  this.props.poAwb.security_notes: '';
    const ccsfNumber: string = this.props.poAwb.ccsf_approval_number ?  this.props.poAwb.ccsf_approval_number: '';
    const exception: string = (this.props.poAwb.flight_exception && this.props.poAwb.unknown_on_pax_flight ) ? this.props.poAwb.flight_exception: '';
    this.setState({ poAwb: this.props.poAwb, flight: this.props.flight, iac, ds, comat, iacNumber, dsNumber, ccsfNumber, exception, statusTransportation: this.props.statusTransportation, statusShipper: this.props.statusShipper, securityNote, itsOkay })
  };

  handlePutPoAwbSecurityCheck = (poNumber: string, awbCode: string, awbNumber: string, ver: number, poAwb: GhaPickupStatusAwb) : void => {

    pickupOrderRemote.updateGhaPoAwbSecurityChecks(poNumber, awbCode, awbNumber, ver, poAwb).then((resp: ApiResponse<GhaPickupStatus>)=> {
      const status: GhaPickupStatus | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (status) {

        const poAwb: GhaPickupStatusAwb = status.po_awb;
        const statusTransportation: boolean = status.valid_transportation ? status.valid_transportation: false
        const statusShipper: boolean = status.valid_shipper_profile ? status.valid_shipper_profile : false;
        this.props.setContainerState(poAwb, statusTransportation, statusShipper );
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  componentDidMount() {
    this.load();
  }

  handleChange = (event: any ): void => {
 
    const value: string = event.target.value;
    const name: string = event.target.id || event.target.name;
    const poAwb: GhaPickupStatusAwb = { ... this.state.poAwb };

    switch (name) {
      case 'exception':
        if (value === '') {
          poAwb.flight_exception = null;
        } else {
          poAwb.flight_exception = value;
        }

        if (value !== '') {
          poAwb.unknown_on_pax_flight = true;
        }

        break;

      case 'ccsf':

        poAwb.ccsf_type = value;
        if (value === 'CCSP' as typeof poAwb.ccsf_type) {
          // When CCSP is selected, use IAC number
          poAwb.ccsf_approval_number = this.state.iacNumber;
          poAwb.ccsf_name = this.props.poAwb.iac_name;
        } else if (value === 'CCSF') {
          // Clear all CCSF related fields when switching to CCSF
          poAwb.ccsf_approval_number = '';
          poAwb.ccsf_name = '';
        } else if (value === 'N/A') {
          poAwb.ccsf_approval_number = '';
          poAwb.ccsf_name = '';
        }
        break;
      default: break;
    }

    switch( value ) {

      case 'iac' :

        if ( this.state.ds || this.state.comat) {
          poAwb.transportation_profile = 'iac';
        }

        const iac: boolean = !this.state.iac;
        poAwb.transportation_profile = iac ? 'iac' :  null;
        poAwb.transportation_number= '';
        if (!iac) {
          poAwb.ccsf_type = 'N/A';
          poAwb.ccsf_approval_number = '';
          poAwb.ccsf_name = '';
          this.setState({ ccsfNumber: '' });
        }
        break;
      case 'iac_its' :

        poAwb.its = poAwb.its === 'iac_its' ? null : 'iac_its';        
        break;
      case 'ccsf_its' :

        poAwb.its = poAwb.its === 'ccsf_its' ? null : 'ccsf_its'; 
        
        break;

      case 'ds':

        if (this.state.iac || this.state.comat) {
          poAwb.transportation_profile = 'ds';
        }

        const ds: boolean = !this.state.ds;
        poAwb.transportation_profile = ds ? 'ds' :  null;
        poAwb.transportation_number= '';
        poAwb.ccsf_type = 'N/A';
        poAwb.ccsf_approval_number = '';
        poAwb.ccsf_name = '';
        this.setState({ ccsfNumber: '' });

        break;
      case 'comat' :

        if (this.state.ds || this.state.iac) {
          poAwb.transportation_profile = 'comat';
        }

        const comat: boolean = !this.state.comat;
        poAwb.transportation_profile = comat ? 'comat' :  null;
        poAwb.transportation_number= '';
        poAwb.ccsf_type = 'N/A';
        poAwb.ccsf_approval_number = '';
        poAwb.ccsf_name = '';
        this.setState({ ccsfNumber: '' });
        break;
      case 'Known' : 

        poAwb.shipper_profile = 'Known'
        poAwb.unknown_on_pax_flight = false;
        poAwb.flight_exception = null;

        break;

      case 'Unknown':

        poAwb.shipper_profile = 'Unknown'; 
        poAwb.ccsf_pre_screened = false;
        poAwb.ccsf_approval_number = '';

        break;

      case 'pax':

        const pax: boolean = !poAwb.unknown_on_pax_flight;
        poAwb.unknown_on_pax_flight = pax;

        if (!pax) {
          poAwb.flight_exception = null;
        };

        break;

      default: break;
    }  
    
    this.handlePutPoAwbSecurityCheck(this.props.doNumber, this.props.code, this.props.number, this.props.awbVer, poAwb);

  };

  handleChangeNumber = (event: any): void => {

    const name: string = event.target.id;
    const value: string = event.target.value;
    const poAwb: GhaPickupStatusAwb = { ... this.state.poAwb };
    switch (name) {

      case 'iacNumber':
        if (poAwb.ccsf_type === 'CCSP') {
          poAwb.ccsf_approval_number = value;
          poAwb.ccsf_name = this.props.poAwb.iac_name;
        }
        this.setState({ iacNumber: value, ccsfNumber: poAwb.ccsf_type === 'CCSP' ? value : this.state.ccsfNumber, poAwb });
        break;
      case 'dsNumber': this.setState({ dsNumber: value }); break;
      case 'ccsfNumber': this.setState({ ccsfNumber: value }); break;
      case 'securityNote': this.setState({ securityNote: value }); break;
      default: break;
    }
  };

  handleSetSNumber = (event: any): void => {

   const name: string = event.target.id;
   const poAwb: GhaPickupStatusAwb = { ... this.state.poAwb };

   switch(name) {

     case 'iacNumber': poAwb.transportation_number=this.state.iacNumber; break;
     case 'dsNumber': poAwb.transportation_number=this.state.dsNumber; break;
     case 'ccsfNumber': poAwb.ccsf_approval_number = this.state.ccsfNumber; break;
     case 'securityNote': poAwb.security_notes = this.state.securityNote; break;
     default: break;
   }

   this.handlePutPoAwbSecurityCheck(this.props.doNumber, this.props.code, this.props.number, this.props.awbVer, poAwb);

  };
 
  render() {
    
    return (

      <SecurityChecks
        iac={ this.state.iac }
        ds={ this.state.ds }
        flightNumber={ this.state.flight }
        iacNumber={ this.state.iacNumber }
        dsNumber={ this.state.dsNumber }
        handleChange={ this.handleChange }
        handleChangeNumber={ this.handleChangeNumber }
        handleSetSNumber={ this.handleSetSNumber }
        shipper={ this.props.poAwb.shipper_profile } 
        ccsf={ this.props.poAwb.ccsf_pre_screened }
        pax={ this.props.poAwb.unknown_on_pax_flight }
        ccsfNumber={ this.state.ccsfNumber }
        exception={ this.state.exception }
        statusTransportation={ this.state.statusTransportation }
        statusShipper={ this.state.statusShipper }
        checkElement={ this.props.checkElement }
        onlyRead={ this.props.onlyRead }
        iacName={ this.props.poAwb.iac_name }
        ccsfName={ this.props.poAwb.ccsf_name }
        shipperName={ this.props.poAwb.shipper_name }
        deliveredDate={ this.props.deliveredDate }
        securityNote={ this.state.securityNote }
        itsOkay={ this.state.itsOkay }
        comat={this.state.comat}
        ccsfType={ this.props.poAwb.ccsf_type }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
}

export default connect(null, mapDispatchToProps)(SecurityChecksContainer);